import { render, staticRenderFns } from "./CorePageSEO.vue?vue&type=template&id=6c5dbf78&"
import script from "./CorePageSEO.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CorePageSEO.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c5dbf78')) {
      api.createRecord('6c5dbf78', component.options)
    } else {
      api.reload('6c5dbf78', component.options)
    }
    module.hot.accept("./CorePageSEO.vue?vue&type=template&id=6c5dbf78&", function () {
      api.rerender('6c5dbf78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/core/CorePageSEO/CorePageSEO.vue"
export default component.exports